import Storage from './storageInBrowser.ts';
import { init } from './logic.ts';

export default init(Storage.init());
